import { differenceInDays, intervalToDuration } from 'date-fns';

const getFullCountdown = (from: Date, to: Date): string => {
  const {
    months = 0,
    days = 0,
    hours = 0,
    minutes = 0,
    seconds = 0,
  } = intervalToDuration({ start: from, end: to });
  // Ask from product team to have difference in days instead of having months
  if (months > 0) {
    return `${differenceInDays(to, from)}d ${hours}h ${minutes}m ${seconds}s`;
  }
  return `${days}d ${hours}h ${minutes}m ${seconds}s`;
};

export default getFullCountdown;
